export default "__VITE_ASSET__DcDgGf$x__"